"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Card = _interopRequireDefault(require("../../Card/Card"));
var SignUp = function SignUp(props) {
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, props.data.full ? /*#__PURE__*/_react["default"].createElement("div", {
    className: "d8-full-signup-card"
  }, /*#__PURE__*/_react["default"].createElement(_Card["default"], {
    template: "ImageCard",
    signUp: true,
    hideLastName: true,
    addressBookId: props.data.addressbookid,
    imageCardTemplate: "SignUp",
    text: props.data.text,
    heading: props.data.heading,
    subheading: props.data.subheading,
    bgImage: {
      url: props.data.image.url || 'https://assets.theyachtweek.com/wp-content/uploads/2020/02/newsletter.jpg',
      alt: props.data.image.alt || 'Birds eye view on blue lagoon with rocks and yacht.'
    },
    whiteFont: true,
    overlay: true
  })) : /*#__PURE__*/_react["default"].createElement("div", {
    className: "container max-width-lg margin-y-xl"
  }, /*#__PURE__*/_react["default"].createElement(_Card["default"], {
    template: "ImageCard",
    signUp: true,
    addressBookId: props.data.addressbookid,
    imageCardTemplate: "SignUp",
    text: props.data.text,
    heading: props.data.heading,
    subheading: props.data.subheading,
    bgImage: {
      url: props.data.image.url || 'https://assets.theyachtweek.com/wp-content/uploads/2020/02/newsletter.jpg',
      alt: props.data.image.alt || 'Birds eye view on blue lagoon with rocks and yacht.'
    },
    whiteFont: true,
    overlay: true
  })));
};
SignUp.propTypes = {
  data: _propTypes["default"].object
};
var _default = exports["default"] = SignUp;